<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="6">
                    <ValidationProvider name="document_type" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('document_type')">
                            <parameter-selectbox :validate-error="errors[0]" v-model="form.document_type"
                                                 code="administrative_document_document_type"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <template v-if="form.document_type">
                    <b-col cols="6">
                        <ValidationProvider name="date_of_document" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('date_of_document')">
                                <b-form-input
                                    v-model="form.date_of_document"
                                    type="date"
                                    :class="errors[0] ? 'is-invalid' : ''"
                                />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="6">
                        <ValidationProvider name="index_by_bau" rules="" v-slot="{ errors }">
                            <b-form-group :label="$t('index_by_bau')">
                                <b-form-input
                                    v-model="form.index_by_bau"
                                    :class="errors[0] ? 'is-invalid' : ''"
                                />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="6">
                        <ValidationProvider name="index_of_document" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('index_of_document')">
                                <b-form-input
                                    v-model="form.index_of_document"
                                    :class="errors[0] ? 'is-invalid' : ''"
                                />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6" v-if="['outgoing_document', 'incoming_document'].includes(form.document_type)">
                        <ValidationProvider name="name_of_sender" :rules="['outgoing_document', 'incoming_document'].includes(form.document_type) ? 'required' : ''"  v-slot="{ errors }">
                            <b-form-group :label="$t('name_of_sender')">
                                <b-form-input
                                    v-model="form.name_of_sender"
                                    :class="errors[0] ? 'is-invalid' : ''"
                                />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6" v-if="['outgoing_document', 'incoming_document'].includes(form.document_type)">
                        <ValidationProvider name="name_of_recipient" :rules="['outgoing_document', 'incoming_document'].includes(form.document_type) ? 'required' : ''" v-slot="{ errors }">
                            <b-form-group :label="$t('name_of_recipient')">
                                <b-form-input
                                    v-model="form.name_of_recipient"
                                    :class="errors[0] ? 'is-invalid' : ''"
                                />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6" v-if="['outgoing_document', 'incoming_document'].includes(form.document_type)">
                        <ValidationProvider name="executor" :rules="['outgoing_document', 'incoming_document'].includes(form.document_type) ? 'required' : ''" v-slot="{ errors }">
                            <b-form-group :label="$t('executor')">
                                <b-form-input
                                    v-model="form.executor"
                                    :class="errors[0] ? 'is-invalid' : ''"
                                />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6" v-if="['outgoing_document', 'incoming_document'].includes(form.document_type)">
                        <ValidationProvider name="delivery_type" :rules="['outgoing_document', 'incoming_document'].includes(form.document_type) ? 'required' : ''" v-slot="{valid, errors}">
                            <b-form-group :label="$t('delivery_type')">
                                <parameter-selectbox :validate-error="errors[0]" v-model="form.delivery_type"
                                                     code="administrative_document_delivery_type"/>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6">
                        <ValidationProvider name="number_of_pages" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('number_of_pages')">
                                <b-form-input
                                    v-model="form.number_of_pages"
                                    type="number"
                                    :class="errors[0] ? 'is-invalid' : ''"
                                />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6" v-if="['rectors_order', 'business_partner_meeting', 'academic_council_order', 'faculty_council_order', 'minutes', 'agreements'].includes(form.document_type)">
                        <ValidationProvider name="grade" :rules="['rectors_order', 'business_partner_meeting', 'academic_council_order', 'faculty_council_order', 'minutes', 'agreements'].includes(form.document_type) ? 'required' : ''" v-slot="{ errors }">
                            <b-form-group :label="$t('grade')">
                                <b-form-input
                                    v-model="form.grade"
                                    :class="errors[0] ? 'is-invalid' : ''"
                                />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12">
                        <ValidationProvider name="explanation" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('explanation')">
                                <b-form-textarea
                                    v-model="form.explanation"
                                    rows="3"
                                    :class="errors[0] ? 'is-invalid' : ''"
                                />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <template v-if="['agreements'].includes(form.document_type)">
                        <b-col cols="6" md="6">
                            <ValidationProvider name="start_date" :rules="['agreements'].includes(form.document_type) ? 'required' : ''"  v-slot="{ valid, errors }">
                                <b-form-group :label="$t('start_date')">
                                    <select-date v-model="form.start_date" :state="errors[0] ? false : null" />
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="6" md="6">
                            <ValidationProvider name="end_date" rules="" v-slot="{ valid, errors }">
                                <b-form-group :label="$t('end_date')">
                                    <select-date v-model="form.end_date" :state="errors[0] ? false : null" />
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6">
                            <b-form-group :label="$t('type_of_agreement')">
                                <parameter-selectbox v-model="form.type_of_agreement"
                                                     code="administrative_document_type_of_agreements"/>
                            </b-form-group>
                        </b-col>
                    </template>
                    <b-col cols="12">
                        <ValidationProvider name="file" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('document_file')">
                                <div class="d-flex custom-file-upload">
                                    <b-form-file
                                        v-model="form.file"
                                        :placeholder="$t('select_file')"
                                        ref="fileInput"
                                    ></b-form-file>
                                </div>
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col cols="12">
                        <ValidationProvider name="annex" rules="" v-slot="{ errors }">
                            <b-form-group :label="$t('annex')">
                                <div class="d-flex custom-file-upload">
                                    <b-form-file
                                        v-model="form.annex"
                                        :placeholder="$t('select_file')"
                                        ref="annexInput"
                                    ></b-form-file>
                                </div>
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                </template>
            </b-row>
        </ValidationObserver>

        <div class="col-6 mt-3 d-flex" v-if="form.document_type">
            <b-button
                @click="createForm"
                type="button"
                :disabled="formLoading"
                variant="primary"
                class="btn-lg mr-2"
            >
                {{ $t("save") | toUpperCase }}
            </b-button>
        </div>
    </div>
</template>

<script>
    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    //Service
    import AdministrativeDocumentManagementService from "@/services/AdministrativeDocumentManagementService";

    export default {
        components: {
            ValidationProvider,
            ValidationObserver,
        },
        data() {
            return {
                formLoading: false,
                form: {
                    document_type: null,
                    date_of_document: null,
                    index_by_bau: null,
                    index_of_document: null,
                    name_of_sender: null,
                    name_of_recipient: null,
                    executor: null,
                    delivery_type: null,
                    number_of_pages: null,
                    grade: null,
                    explanation: null,
                    start_date: null,
                    end_date: null,
                    type_of_agreement: null,
                    file: null,
                    annex: null
                },
            }
        },
        watch: {
            'form.document_type': function(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.handleTypeChange(newVal);
                }
            }
        },
        methods: {
            async createForm() {
                const isValid = await this.$refs.formModalValidate.validate()
                if (isValid) {
                    this.formLoading = true;

                    const formData = new FormData();
                    Object.keys(this.form).forEach((key) => {
                        const value = this.form[key];

                        if (value !== null && value !== undefined) {
                            formData.append(key, value);
                        }
                    });

                    AdministrativeDocumentManagementService.store(formData)
                                    .then((response) => {
                                        this.$toast.success(this.$t("api." + response.data.message));
                                        this.$emit("createFormSuccess")
                                    })
                                    .catch((error) => {
                                        this.showErrors(error, this.$refs.formModalValidate)
                                    }).finally(() => {
                        this.formLoading = false;
                    });
                }
            },
            clearFormData() {
                Object.keys(this.form).forEach((key) => {
                    this.form[key] = null;
                });
            },
            handleTypeChange(newType) {
                if (this.$refs.formModalValidate) {
                    this.$nextTick(() => {
                        this.$refs.formModalValidate.reset();
                    });
                }
                this.clearFormData();
                this.form.document_type = newType;
            },
        }
    }
</script>
